import types from '../types'
import axios from 'axios'
import { getApiServer } from '../../utils/helpers'
import { saveWrapUp } from '../../redux/actions/wrapup'

const serverURL = getApiServer()

export const getItems = () => async (dispatch, getState) => {
  const { patient: { patient, encounter } } = getState()
  try {
    dispatch({ type: types.GET_ASSESSMENT_ITEMS_REQUESTED })
    const items = await axios.get(serverURL + '/api/items', { params: { patientId: patient.patientId, encounterId: encounter.encounterId } })
    dispatch({ type: types.GET_ASSESSMENT_ITEMS_FULFILLED, payload: items.data })
  } catch (error) {
    dispatch({ type: types.SET_ASSESSMENT_ITEMS_REJECTED, payload: error })
  }
}

export const generatePatientAssessment = () => async (dispatch, getState) => {
  const { patient: { encounter, patient }, healthSystem: { healthSystem } } = getState()
  try {
    dispatch({ type: types.SET_ASSESSMENT_FETCHING })
    const assessmentData = await axios.get(`${serverURL}/api/assessment`, { params: { encounter: encounter.encounterId, patient: patient.patientId, healthSystemId: healthSystem.healthSystemId } })
    const { patientHistory, rulesData } = assessmentData.data
    dispatch({ type: types.SET_ASSESSMENT_ENCOUNTER, payload: { patientHistory, rulesData } })
  } catch (error) {
    dispatch({ type: types.SET_ASSESSMENT_ERROR, payload: error })
  }
}

export const getPatientAssessment = () => async (dispatch, getState) => {
  const { patient: { encounter, patient } } = getState()
  dispatch({ type: types.SET_ASSESSMENT_FETCHING })
  try {
    const session = await axios.get(serverURL + '/api/encounter', { params: { encounterId: encounter.encounterId } })
    const patientHistory = await axios.get(serverURL + '/api/patient-history', { params: { encounterId: encounter.encounterId, patientId: patient.patientId } })
    dispatch({ type: types.GET_ASSESSMENT_FULFILLED, payload: { encounter: session.data.encounter, patientHistory: patientHistory.data.assessments, s2kRules: session.data.rulesData } })
    dispatch({ type: types.SET_PATIENT_DATA, payload: patientHistory.data.data })
  } catch (error) {
    console.log(error)
    dispatch({ type: types.SET_ASSESSMENT_ERROR, payload: error })
  }
}

export const setPga = (pga) => (dispatch) => {
  dispatch({ type: types.SET_ASSESSMENT_PGA, payload: pga })
}

export const updateS2k = (event, score) => (dispatch) => {
  dispatch({ type: types.UPDATE_ASSESSMENT_S2K, payload: { event, score } })
}

export const clearAssessment = (event) => (dispatch) => {
  dispatch({ type: types.CLEAR_ASSESSMENT, payload: { event } })
}

export const setNoFlare = () => (dispatch) => {
  dispatch({ type: types.SET_ASSESSMENT_NO_FLARE })
}

export const resetFlare = () => (dispatch) => {
  dispatch({ type: types.RESET_ASSESSMENT_FLARE })
}

export const updateFlare = (key, flare, description) => (dispatch) => {
  dispatch({ type: types.UPDATE_ASSESSMENT_FLARE, payload: { key, flare, description } })
}

export const updateLLDAS = (event) => (dispatch) => {
  dispatch({ type: types.UPDATE_ASSESSMENT_LLDAS, payload: event.target })
}

export const resetLLDAS = () => (dispatch) => {
  dispatch({ type: types.RESET_ASSESSMENT_LLDAS })
}

export const updateDamage = (section, event) => (dispatch) => {
  dispatch({ type: types.UPDATE_ASSESSMENT_DAMAGE, payload: { section, event: event.target } })
}

export const setNoDamageIndex = () => (dispatch) => {
  dispatch({ type: types.SET_ASSESSMENT_NO_DAMAGE_INDEX })
}

export const resetDamage = () => (dispatch) => {
  dispatch({ type: types.RESET_ASSESSMENT_DAMAGE })
}

export const saveAssessment = (encounter, pga, flare, s2k, damage, lldas, flareIsNull, damageIsNull) => async (dispatch) => {
  dispatch({ type: types.SAVE_ASSESSMENT_REQUESTED })
  Promise.all([
    await axios.post(serverURL + '/api/pga', {
      encounterId: encounter.encounterId,
      pga
    }),
    await axios.post(serverURL + '/api/flare', {
      encounterId: encounter.encounterId,
      flare,
      flareIsNull
    }),
    await axios.post(serverURL + '/api/s2k', {
      encounterId: encounter.encounterId,
      s2k
    }),
    await axios.post(serverURL + '/api/damage', {
      encounterId: encounter.encounterId,
      damage,
      damageIsNull
    }),
    await axios.post(serverURL + '/api/lldas', {
      encounterId: encounter.encounterId,
      lldas
    })
  ])
    .then(() => {
      dispatch({ type: types.SAVE_ASSESSMENT_FULFILLED })
    })
    .catch((error) => {
      dispatch({ type: types.SAVE_ASSESSMENT_REJECTED, payload: error })
    })
}

export const exitAction = (encounterId, notes, activeKey) => async (dispatch) => {
  if (activeKey === 'wrapup') {
    dispatch(saveWrapUp(encounterId, notes))
      .then(() => {
        dispatch({ type: types.EXIT_ASSESSMENT })
      }).catch((error) => {
        console.log('Wrap Up saving failed ')
        console.log(error)
      })
  } else {
    dispatch({ type: types.EXIT_ASSESSMENT })
  }
}

export const setPendS2k = (pend) => (dispatch) => dispatch({ type: types.SET_PEND_S2K, payload: pend })
